import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { AuthService } from '../../Service/auth.service';
import Swal from 'sweetalert2'
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/assets/Constats';
import { User } from 'src/app/models/shared/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedConstants } from 'src/app/models/shared/shared.constants';
import { CookieService } from 'ngx-cookie-service';
import { EnumRoutesDefault } from 'src/app/models/shared/app-enums';
import { CatGeneric } from 'src/app/models/shared/cat-generic';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit, OnDestroy {
  private config: { version: string };
  _versionApp: string;
  private cookieService = inject(CookieService);
  currentUser: User;

  options: AnimationOptions = {
    path: 'assets/animation/login.json',
  };

  fmLogin: FormGroup;
  waitFor = false;
  error: string = '';
  email = '';
  translateSweetAlert: any;
  user: User;
  returnUrl: string;
  show: boolean;
  explorerName: string;
  regexEmail: string;
  catLang: CatGeneric[] = [];

  constructor(private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly authenticationService: AuthService,
    private readonly translate: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly http: HttpClient,
    private readonly sharedConstants: SharedConstants,
  ) {

    this.onLogOut();

    this.regexEmail = this.sharedConstants.regexPattern.passwordValidator;
    this.fmLogin = this.formBuilder.group({
      username: ['', [Validators.required, Validators.minLength(5)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      ddlLang: ['es'],
    });
    //Cargar los idiomas
    this.translate.addLangs(['es', 'en']);

    this.catLang.push({ id: 1, name: "Español", value: "es" });
    this.catLang.push({ id: 2, name: "English", value: "en" });

    this.user = new User();
    this.show = false;
    this.onCheckUser();
  }
  get f() { return this.fmLogin.controls; }

  changeInput() {
    this.show = !this.show;
  }


  onChangeLang(event: any) {
    let lang = event.value;
    localStorage.setItem("lang", lang);
    this.translate.use(lang);
  }

  animationCreated(animationItem: AnimationItem): void {
    //console.log(animationItem);
  }

  loginUser(values: any) {

    localStorage.setItem("lang", values.ddlLang);

    this.waitFor = true;
    this.authenticationService.login(values.username, values.password)
      .subscribe(res => {
        console.log(res);
        if (res.body) {
          if (res.body.code == "OPERATION_FAILED") {
            this.error = res.body.message;
            this.waitFor = false;
          } else if (res.info.length > 0) {
            this.error = "No puede iniciar sesión porque ya está logueado con otro usuario. Para continuar cierre sesión y vuelva a intentar.";
            this.waitFor = false;
          } else {
            localStorage.setItem('logueado', "1");
            localStorage.setItem('isInitLoad', "1");
            console.log("Sesión iniciada");
          }
        }

      },
        err => {

          console.log("PASA");
          localStorage.setItem('logueado', "0");
          if (err.status === 401) {
            this.translate.stream('login.loginFail401').subscribe((res: string) => {
              console.log(res);
              this.error = res;
            });

          } else {
            this.translate.stream('login.loginFail').subscribe((res: string) => {
              console.log(res);
              this.error = res;
            });
          }
          this.waitFor = false;
        });

  }

  resetPassword() {
    const inputValue = 345.67
    const inputStep = 0.01
    Swal.fire({
      title: "Restablecer contraseña",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
      input: 'email',
      inputAttributes: {
        maxlength: "50"
      },
      inputLabel: "Ingresa tu correo electrónico",

      inputPlaceholder: "Ingresa tu correo electrónico",


    }).then((result) => {
      if (result.value) {
        this.user.email = result.value;
        let email = { "email": result.value };

        this.http.post<any>('/auth/reset-password', email).subscribe(
          (response: any) => {
            Swal.fire({
              title: "Correo encontrado.",
              icon: 'success',
              confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
            });
            this.waitFor = false;
          }, (error: Response) => {
            Swal.fire({
              title: "Se presentó un problema al procesar su solicitud.",
              icon: 'error',
              confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
            });
            this.waitFor = false;
          });
      }
    })
  }

  ngOnInit(): void {
    console.log("ngOnInit login");
    this.getVersionApp();
  }



  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    // alert(agent);
    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  ngOnDestroy() {
    window.location.reload();
  }

  onCheckUser() {
    console.info("onCheckUser");
    let _old = this.cookieService.get('userId');
    //Si existe usuario entonces se manda al dash
    if (_old != undefined && _old != '') {
      this.router.navigate([EnumRoutesDefault.UserCae]);
    }
    else {
      console.log("Limpiando datos");
      this.authService.onClearDataUser();
    }
  }

  onLogOut() {
    console.info("onLogOut");
    console.log("Limpiando datos");
    this.authService.onClearDataUser();
  }

  onValidateCookieUserView() {
    this.authService.onValidateCookieUserUI();
  }

  getVersionApp() {
    this.config = require('../../../assets/config/config.json');
    console.log(this.config.version);

    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');

    this.http
      .get<{ version: string }>("/assets/config/config.json", { headers })
      .subscribe(config => {
        console.log(config);
        this._versionApp = "v" + config.version;
      });
  }

  onChangeInputPass() {
    this.show = !this.show;
  }
}
